import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ActionCreators } from "../../_actions/ActionCreators";
import CarrinhoService from "../../services/CarrinhoService";
import FreteService from "../../services/FreteService";
import { PagamentoProcessandoContentStyle } from "./style";
import TagueamentoService from "../../services/TagueamentoService";

const tagueamentoService = new TagueamentoService();

function PagamentoProcessando({
  tipoPagamento = "carteira_flex",
  fretesCarinho = [],
  somaValorTotalFretes,
  uuidCarinho,
}) {
  const dispatch = useDispatch();
  const freteService = new FreteService();
  const carrinhoService = new CarrinhoService();

  const [erro, setErro] = useState(null);
  const [sucesso, setSucesso] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uuidCarinho) {
      setErro("Carrinho não encontrado.");
      setLoading(false);
      return;
    }

    freteService.comprarFrete(uuidCarinho, (erroFrete, resposta) => {
      setLoading(false);

      if (erroFrete) {
        setErro(erroFrete);
        return;
      }

      if (resposta) {
        const amount = Number(somaValorTotalFretes.toFixed(2));
        tagueamentoService.eventoMarketingCheckoutTransparente(
          fretesCarinho,
          tipoPagamento,
          amount,
          resposta.uuid,
          uuidCarinho
        );
        carrinhoService.deleteCalculadoraFormInfo();
        dispatch(ActionCreators.setFreteCompradoComSucesso(resposta));
        dispatch(ActionCreators.setCarrinhoInformacoes([]));
        carrinhoService.setNumeroItensInfosParaCompra(0);

        setSucesso(resposta);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, uuidCarinho]);

  return (
    <PagamentoProcessandoContentStyle>
      <div className="content">
        {loading && (
          <>
            <div className="spinner" />
            <p>O seu pagamento está sendo processado...</p>
          </>
        )}

        {!loading && !erro && !sucesso && (
          <>
            <div className="icon pending">!</div>
            <h2>O seu pagamento está pendente.</h2>

            <p>{erro}</p>
            <button onClick={() => (window.location.href = "/carteira")}>Carteira flex</button>
          </>
        )}

        {erro && (
          <>
            <div className="icon error">✕</div>
            <h2>
              O seu pagamento <b>não</b> foi confirmado.
            </h2>
            <p>Motivo: {erro}</p>
            <button onClick={() => window.location.reload()}>Voltar</button>
          </>
        )}

        {sucesso && (
          <>
            <div className="icon success">✓</div>
            <h2>O seu pagamento já foi confirmado!</h2>
            <button onClick={() => (window.location.href = "/envios")}>Meus Fretes</button>
          </>
        )}
      </div>
    </PagamentoProcessandoContentStyle>
  );
}

export default PagamentoProcessando;
